module.exports = __webpack_public_path__ + "img/rku10-7.8677fc4a.png";